import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { FaSearch, FaPlus, FaTimes, FaFilter, FaUserPlus, FaEdit, FaTrash, FaEye, FaGripVertical  } from 'react-icons/fa';
import { useMasterData } from '../../hooks/useMasterData';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { MdRefresh } from "react-icons/md";
import { CourseSelect, SessionSelect } from '../../components/MasterDataSelect';
import {API_BASE_URL} from '../../utils/apiConfig';
import { fetchMasterData } from '../../store/slices/masterDataSlice';
const Container = styled.div`
  padding: 30px;
  background: #f8f9fa;
  min-height: 100vh;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
`;

const Title = styled.h1`
  color: #2c3e50;
  margin: 0;
  font-size: 1.5rem;
`;

const ActionButtons = styled.div`
  display: flex;
  gap: 15px;
`;

const SearchButton = styled.button`
  border: none;
  padding: 12px 20px;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
  transition: transform 0.2s ease;
  background: transparent;
  border: 1px solid #e9ecef;
  color: #2f2e2e;

  &:hover {
    transform: translateY(-2px);
  }
`;

const SearchInput = styled.input`
  padding: 12px 16px;
  border: 2px solid #e1e5e9;
  border-radius: 8px;
  font-size: 16px;
  transition: border-color 0.3s ease;
  background: white;

  &:focus {
    outline: none;
    border-color: rgb(51, 66, 147);
  }
`;

const AddButton = styled.button`
  color: rgb(51, 66, 147);
  padding: 12px 20px;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
  transition: transform 0.2s ease;
border: none;
  &:hover {
    transform: translateY(-2px);
  }
`;

const TableContainer = styled.div`
  background: white;
  border-radius: 15px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.08);
  overflow: hidden;
`;

const TableHeader = styled.div`
  background: #f8f9fa;
  padding: 20px;
  border-bottom: 1px solid #e9ecef;
  display: flex;
  align-items: center;
  gap: 10px;
`;

const CheckboxInput = styled.input`
  margin-right: 10px;
  transform: scale(1.2);
`;

const HeaderText = styled.span`
  font-weight: 600;
  color: #2c3e50;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  display: inline-table;
`;

const Thead = styled.thead`
  background: #f8f9fa;
`;

const Th = styled.th`
  padding: 15px 20px;
  text-align: left;
  font-weight: 600;
  color: #2c3e50;
  border-bottom: 2px solid #e9ecef;
  font-size: 0.9rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

const Tbody = styled.tbody``;

const Tr = styled.tr`
  &:hover {
    background: #f8f9fa;
  }
  
  &:not(:last-child) {
    border-bottom: 1px solid #e9ecef;
  }
`;

const Td = styled.td`
  padding: 15px 20px;
  color: #495057;
  font-size: 0.95rem;
`;

const StudentName = styled.div`
  font-weight: 500;
  color: #2c3e50;
`;

const StudentEmail = styled.div`
  color: rgb(51, 66, 147);;
  font-size: 0.9rem;
  margin-top: 2px;
`;

const AssignButton = styled.button`
   border: 1px solid rgb(52 152 219);
  color: rgb(52 152 219);
  padding: 8px 20px;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 600;
  font-size: 0.9rem;
  transition: all 0.2s ease;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
  }
`;

const SSNDisplay = styled.span`
  font-family: 'Courier New', monospace;
  font-weight: 500;
`;

const GenderBadge = styled.span`
  display: inline-block;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 0.8rem;
  font-weight: 600;
  background: ${props => props.gender === 'Female' ? '#ffe6f2' : '#e6f3ff'};
  color: ${props => props.gender === 'Female' ? '#d63384' : '#0066cc'};
`;

// Modal Styles
const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
`;

const ModalContainer = styled.div`
  background: white;
  border-radius: 15px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  width: 100%;
  max-width: 1150px;
  max-height: 90vh;
  overflow-y: auto;
`;

const ModalHeader = styled.div`
  padding: 25px 30px;
  border-bottom: 1px solid #e9ecef;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const ModalTitle = styled.h2`
  color: #2c3e50;
  margin: 0;
  font-size: 1.5rem;
  font-weight: 600;
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 1.5rem;
  color: #6c757d;
  cursor: pointer;
  padding: 5px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  
  &:hover {
    background: #f8f9fa;
    color: #2c3e50;
  }
`;

const ModalBody = styled.div`
  padding: 30px;
`;

const FormRow = styled.div`
  display: flex;
  gap: 20px;
  margin-bottom: 25px;
  
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 15px;
  }
`;

const FormGroup = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

const Label = styled.label`
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 8px;
  font-size: 0.95rem;
  
  &.required::after {
    content: ' *';
    color: #e74c3c;
  }
`;

const Select = styled.select`
  padding: 12px 15px;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  font-size: 0.95rem;
  color: #495057;
  background: white;
  
  &:focus {
    outline: none;
    border-color: rgb(51, 66, 147);;
    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
  }
`;

const StudentTag = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 15px;
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  font-size: 0.95rem;
  color: #495057;
`;

const RemoveStudentButton = styled.button`
  background: none;
  border: none;
  color: #6c757d;
  cursor: pointer;
  font-size: 0.9rem;
  
  &:hover {
    color: #e74c3c;
  }
`;

const SectionTitle = styled.h3`
  color: #2c3e50;
  margin: 30px 0 20px 0;
  font-size: 1.2rem;
  font-weight: 600;
  border-bottom: 2px solid #e9ecef;
  padding-bottom: 10px;
`;

const ModalFooter = styled.div`
  padding: 20px 30px;
  border-top: 1px solid #e9ecef;
  display: flex;
  justify-content: flex-end;
`;

const SubmitButton = styled.button`
  background: rgb(51, 66, 147);;
  color: white;
  border: none;
  padding: 12px 30px;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 600;
  font-size: 1rem;
  transition: all 0.2s ease;
  opacity: ${props => props.disabled ? 0.5 : 1};
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};

  &:hover {
    ${props => !props.disabled && `
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
    `}
  }
`;

const FilterSection = styled.div`
  background: white;
  padding: 20px;
  border-radius: 15px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.08);
  margin-bottom: 30px;
`;

const FilterRow = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap;
`;

const FilterGroup = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 200px;
`;

const FilterLabel = styled.label`
  margin-bottom: 8px;
  color: #333;
  font-weight: 500;
  font-size: 0.9rem;
`;

const AssignSession = () => {
  const dispatch = useDispatch();
  const { students, isLoading } = useMasterData();
  const { courses: masterCourses, sessions: masterSessions } = useSelector(state => state.masterData);
  const [selectedStudents, setSelectedStudents] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [formData, setFormData] = useState({
    course: '',
    session: ''
  });
  const [apiMessage, setApiMessage] = useState(null);
  const [apiError, setApiError] = useState(null);
  
  // Add filter state
  const [filters, setFilters] = useState({
    course: '',
    session: ''
  });
  const [filteredStudents, setFilteredStudents] = useState([]);
  const [isFiltered, setIsFiltered] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');

  const navigate = useNavigate();

  // Filter sessions by selected course
  const filteredSessions = formData.course 
    ? masterSessions.filter(session => session.course_id == formData.course || session.course_id == parseInt(formData.course))
    : [];

  // Check if form is valid (student, course, and session are selected)
  const isFormValid = selectedStudent && formData.course && formData.session;

  // Helper function to get course name by ID
  const getCourseName = (courseId) => {
    if (!courseId) return null;
    const course = masterCourses.find(c => c.id == courseId || c.id == parseInt(courseId));
    return course ? course.course_name : null;
  };

  // Helper function to get session name by ID
  const getSessionName = (sessionId) => {
    if (!sessionId) return null;
    const session = masterSessions.find(s => s.id == sessionId || s.id == parseInt(sessionId));
    return session ? session.session_name : null;
  };

  // Auto-search when filters change
  useEffect(() => {
    handleSearch();
  }, [filters]);

  const handleFilterChange = (field, value) => {
    setFilters({
      ...filters,
      [field]: value
    });
  };

  const handleSearch = () => {
  
    // If no filters are selected, show all students
    if (!filters.course && !filters.session) {
      setFilteredStudents([]);
      setIsFiltered(false);
      return;
    }

    let filtered = students;

    if (filters.course) {
      filtered = filtered.filter(student => 
        student.course === filters.course || 
        student.course?.toLowerCase() === filters.course.toLowerCase()
      );
    }

    if (filters.session) {
      // Find the session object for the selected session ID
      const selectedSession = masterSessions.find(s => String(s.id) === String(filters.session));
      
      filtered = filtered.filter(student => {
        // If student has no session data, skip them
        if (!student.session) {
          return false;
        }
        
        // Try multiple matching strategies
        const studentSession = student.session;
        const sessionId = filters.session;
        const sessionName = selectedSession?.session_name;
        
        // Match by session ID
        if (String(studentSession) === String(sessionId)) {
          return true;
        }
        
        // Match by session name
        if (sessionName && String(studentSession) === String(sessionName)) {
          return true;
        }
        
        // Match by session name (case insensitive)
        if (sessionName && studentSession?.toLowerCase() === sessionName.toLowerCase()) {
          return true;
        }
        
        // Match by session ID as string comparison
        if (studentSession && sessionId && studentSession.toString() === sessionId.toString()) {
          return true;
        }
        
        return false;
      });
    }
    
    setFilteredStudents(filtered);
    setIsFiltered(true);
  };

  const handleClearFilters = () => {
    setFilters({
      course: '',
      session: ''
    });
    setFilteredStudents([]);
    setIsFiltered(false);
  };

  // Get the students to display (filtered or all)
  const displayStudents = isFiltered ? filteredStudents : students;

  // Text search functionality
  const textFilteredStudents = displayStudents.filter(student => {
    const searchLower = searchTerm.toLowerCase();
    return (
      student.firstName?.toLowerCase().includes(searchLower) ||
      student.lastName?.toLowerCase().includes(searchLower) ||
      student.email?.toLowerCase().includes(searchLower) ||
      student.registration_number?.toLowerCase().includes(searchLower)
    );
  }).sort((a, b) => {
    // Sort by last name first, then by first name
    const aLastName = (a.lastName || '').toLowerCase();
    const bLastName = (b.lastName || '').toLowerCase();
    const aFirstName = (a.firstName || '').toLowerCase();
    const bFirstName = (b.firstName || '').toLowerCase();
    
    if (aLastName !== bLastName) {
      return aLastName.localeCompare(bLastName);
    }
    return aFirstName.localeCompare(bFirstName);
  });

  const locations = [
    'Main Campus @ Thorek Memorial Hospital',
    'Evergreen Park Campus'
  ];

  const daysOptions = [
    'Weekdays @ Main Campus - Thorek',
    'Weekends @ Main Campus - Thorek',
    'Evenings @ Main Campus - Thorek',
    'Weekdays @ Evergreen Park Campus',
    'Weekends @ Evergreen Park Campus',
    'Evenings @ Evergreen Park Campus'
  ];

  const handleSelectAll = (e) => {
    const isChecked = e.target.checked;
    setSelectAll(isChecked);
    if (isChecked && students) {
      setSelectedStudents(students.map(student => student.id));
    } else {
      setSelectedStudents([]);
    }
  };

  const handleSelectStudent = (studentId) => {
    setSelectedStudents(prev => {
      if (prev.includes(studentId)) {
        return prev.filter(id => id !== studentId);
      } else {
        return [...prev, studentId];
      }
    });
  };

  const handleAssign = (studentId) => {
    const student = students.find(s => s.id === studentId);
    setSelectedStudent(student);
    setFormData({
      course: student.course || '',
      session: student.session || ''
    });
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedStudent(null);
    setFormData({
      course: '',
      session: ''
    });
  };

  const handleFormChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));

    // Reset session when course changes
    if (field === 'course') {
      setFormData(prev => ({
        ...prev,
        session: ''
      }));
    }
  };

  const handleSubmit = async () => {
    setApiMessage(null);
    setApiError(null);
    
    // Early return if form is not valid
    if (!isFormValid) {
      return;
    }
    
    if (!selectedStudent) {
      setApiError('Please select a student.');
      return;
    } else if (!formData.course) {
      setApiError('Please select a course.');
      return;
    } else if (!formData.session) {
      setApiError('Please select a session.');
      return;
    }
    try {
      const response = await axios.post(`${API_BASE_URL}/students/assign-course`, {
        studentId: selectedStudent.id,
        course: formData.course,
        session: formData.session
      });
      if (response.data.success) {
        setApiMessage(response.data.message || 'Course assigned successfully.');
        setTimeout(() => {
          closeModal();
          setApiMessage(null);
          dispatch(fetchMasterData()); // Refetch students data to show updated information
        }, 1500);
      } else {
        setApiError(response.data.message || 'Failed to assign course.');
      }
    } catch (err) {
      setApiError(
        err.response?.data?.message || 'Server error while assigning course.'
      );
    }
  };

  return (
    <Container>
      <Header>
        <Title>Assign Session & Course</Title>
        
      </Header>

      <FilterSection>
        <FilterRow>
          <FilterGroup>
            <FilterLabel htmlFor="name">Search by name</FilterLabel>
            <SearchInput
              type="text"
              placeholder="Search students..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </FilterGroup>

          <div style={{ display: 'flex', gap: '20px', alignItems: 'flex-end' }}>
            <FilterGroup>
              <FilterLabel htmlFor="course">Course *</FilterLabel>
              <CourseSelect
                value={filters.course}
                onChange={(value) => handleFilterChange('course', value)}
                placeholder="Select course"
                isClearable={true}
                style={{
                  padding: '11px'
                }}
              />
            </FilterGroup>

            <FilterGroup>
              <FilterLabel htmlFor="session">Session *</FilterLabel>
              <SessionSelect
                value={filters.session}
                onChange={(value) => handleFilterChange('session', value)}
                placeholder="Select session"
                isClearable={true}
                courseId={filters.course}
                sessions={masterSessions}
                style={{
                  padding: '11px'
                }}
              />
            </FilterGroup>

            <SearchButton onClick={handleSearch} style={{ padding: '14px' }}>
              <FaSearch />
              Search
            </SearchButton>

            {isFiltered && (
              <SearchButton 
                onClick={handleClearFilters}
                style={{ background: '#6c757d', marginLeft: '10px' }}
              >
                <FaTimes />
                Clear
              </SearchButton>
            )}
          </div>
        </FilterRow>
      </FilterSection>

      <TableContainer>
        {/* <TableHeader>
          <CheckboxInput
            type="checkbox"
            checked={selectAll}
            onChange={handleSelectAll}
          />
          <HeaderText>Student Details</HeaderText>
        </TableHeader> */}

        <Table>
          <Thead>
            <Tr>
              <Th style={{ width: '50px' }}></Th>

              <Th>ID</Th>
              <Th>Last Name</Th>
              <Th>First Name</Th>
              <Th>Email Address</Th>
              <Th>Gender</Th>
              <Th>Phone Number</Th>
              <Th>Enrollment Date</Th>
              <Th>Assigned Course</Th>
              <Th style={{ width: '120px' }}>Action</Th>
            </Tr>
          </Thead>
          <Tbody>
            {textFilteredStudents && textFilteredStudents.length > 0 ? textFilteredStudents.map((student) => (
              <Tr key={student.id}>
                <Td>
                  {/* <CheckboxInput
                    type="checkbox"
                    checked={selectedStudents.includes(student.id)}
                    onChange={() => handleSelectStudent(student.id)}
                  /> */}
                </Td>
                <Td style={{ fontWeight: '500' }}>{student.id}</Td>
                <Td>
                  <StudentName>{student.lastName}</StudentName>
                </Td>
                <Td>
                  <StudentName>{student.firstName}</StudentName>
                </Td>
                <Td>
                  {student.email ? (
                    <StudentEmail>{student.email}</StudentEmail>
                  ) : (
                    <StudentEmail>N/A</StudentEmail>
                  )}
                </Td>
                <Td>
                  {student.gender ? (
                    <GenderBadge gender={student.gender}>
                      {student.gender}
                    </GenderBadge>
                  ) : (
                    <GenderBadge gender="N/A">N/A</GenderBadge>
                  )}
                </Td>
                <Td>
                  {student.phone && (
                    <SSNDisplay>{student.phone}</SSNDisplay>
                  )}
                </Td>
                <Td>
                  {student.enrollmentDate ? (
                    <SSNDisplay>{student.enrollmentDate}</SSNDisplay>
                  ) : (
                    <SSNDisplay>N/A</SSNDisplay>
                  )}
                </Td>
                <Td>
                  {student.course ? (
                    <div>
                      <div style={{ fontWeight: '500', color: '#2c3e50' }}>
                        {getCourseName(student.course)}
                      </div>
                      {student.session && (
                        <div style={{ fontSize: '0.85rem', color: '#6c757d', marginTop: '2px' }}>
                          Session: {getSessionName(student.session)}
                        </div>
                      )}
                    </div>
                  ) : (
                    <span style={{ color: '#6c757d', fontStyle: 'italic' }}>No course assigned</span>
                  )}
                </Td>
                <Td>
                  <AssignButton onClick={() => handleAssign(student.id)}>
                    <FaGripVertical />
                  </AssignButton>
                </Td>
              </Tr>
            )) : (
              <Tr>
                <Td colSpan="10" style={{ textAlign: 'center', padding: '20px' }}>
                  {isLoading ? 'Loading students...' : (isFiltered ? 'No students found matching the selected criteria' : (searchTerm ? 'No students found matching the search term' : 'No students found'))}
                </Td>
              </Tr>
            )}
          </Tbody>
        </Table>
      </TableContainer>

      {/* Modal */}
      {isModalOpen && (
        <ModalOverlay onClick={closeModal}>
          <ModalContainer onClick={(e) => e.stopPropagation()}>
            <ModalHeader>
              <ModalTitle>
                {selectedStudent && selectedStudent.course ? 'Change Course & Session' : 'Assign Course & Session'}
              </ModalTitle>
              <CloseButton onClick={closeModal}>
                <FaTimes />
              </CloseButton>
            </ModalHeader>

            <ModalBody>
              {apiError && <div style={{ color: 'red', marginBottom: 10 }}>{apiError}</div>}
              {apiMessage && <div style={{ color: 'green', marginBottom: 10 }}>{apiMessage}</div>}
              <FormRow>
                <FormGroup>
                  <Label className="required">Student</Label>
                  {selectedStudent && (
                    <StudentTag>
                      <span>{selectedStudent.firstName} {selectedStudent.lastName}</span>
                      <RemoveStudentButton onClick={closeModal}>
                        <FaTimes />
                      </RemoveStudentButton>
                    </StudentTag>
                  )}
                </FormGroup>
              </FormRow>

              <FormRow>
                <FormGroup>
                  <Label className="required">Course</Label>
                  <CourseSelect
                    value={formData.course}
                    onChange={(value) => handleFormChange('course', value)}
                    placeholder="Select course"
                    isClearable={false}
                    style={{
                      padding: '11px'
                    }}
                  />
                </FormGroup>
                <FormGroup>
                  <Label className="required">Session</Label>
                  <SessionSelect
                    value={formData.session}
                    onChange={(value) => handleFormChange('session', value)}
                    placeholder={filteredSessions.length > 0 ? 'Select session' : 'No sessions available'}
                    isClearable={false}
                    isDisabled={!formData.course || filteredSessions.length === 0}
                    courseId={formData.course}
                    sessions={masterSessions}
                    style={{
                      padding: '11px'
                    }}
                  />
                </FormGroup>
              </FormRow>
            </ModalBody>

            <ModalFooter>
              <SubmitButton onClick={handleSubmit} disabled={!isFormValid}>
                {selectedStudent && selectedStudent.course ? 'Update' : 'Assign'}
              </SubmitButton>
            </ModalFooter>
          </ModalContainer>
        </ModalOverlay>
      )}
    </Container>
  );
};

export default AssignSession; 